import { NameFieldProps } from "../../../types/salesDocuments.types";

export const MeterNameComponent: React.FC<NameFieldProps> = ({
  meter,
  readOnly,
  hidden,
  onNameChange,
}) => {
  if (hidden) return null;
  return (
    <div className="sales-doc-field mb-3">
      <label htmlFor={`meter-${meter.id.toString()}-name`} className="form-label">
        Meter Name
      </label>
      <input
        id={`meter-${meter.id.toString()}-name`}
        type="text"
        className="form-control"
        value={meter.name}
        readOnly={readOnly}
        onChange={(e) => {
          onNameChange(meter.id, e.target.value);
        }}
      />
    </div>
  );
};
